import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Tabs from '../Home/components/Tabs';
// import ExistingCustomerIcon from '../assets/icons/self_service_signup.svg'; // Update path to your icon
// import NewCustomerIcon from '../assets/icons/self_service_signup.svg'; // Update path to your icon
// import PreRegistrationIcon from '../assets/icons/self_service_signup.svg'; // Update path to your icon
// import { SiD } from 'react-icons/si';
import Sidebar from '../Home/components/Sidebar';

const LandingPage = () => {
  const [workflows, setWorkflows] = useState([]);
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('');

  useEffect(() => {
    const fetchWorkflows = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/workflows/list`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );
        if (response.ok) {
          const data = await response.json();
          setWorkflows(data);
        } else {
          console.error('Failed to fetch workflows');
        }
      } catch (error) {
        console.error('Error fetching workflows:', error);
      }
    };

    fetchWorkflows();
  }, []);

  const handleCardClick = (workflowId) => {
    navigate(`/workflow/preview/${workflowId}`);
  };

  return (
    <div style={{ display: 'flex', height: '100vh' }}>
      <Sidebar />

      <div style={{ padding: '20px', flexGrow: 1 }}>
        <Tabs activeTab={activeTab} setActiveTab={setActiveTab} />
        <h1>Demo page</h1>
        <p>
          This page is just to show you how to access the different landing
          pages. This is not for development.
        </p>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '20px',
            marginTop: '40px',
          }}
        >
          {workflows.map((workflow) => (
            <div
              key={workflow.id}
              onClick={() => handleCardClick(workflow.id)}
              style={{
                width: '200px',
                padding: '20px',
                border: '1px solid #ddd',
                borderRadius: '10px',
                cursor: 'pointer',
                boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                transition: 'transform 0.2s',
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.transform = 'scale(1.05)')
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.transform = 'scale(1)')
              }
            >
              <h3>{workflow.workflow_name}</h3>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
